





















































































import mixins from 'vue-typed-mixins';
import { PageModeMixin } from '@/main/mixins/pageMode';

import ProvozovnaSelect from '../../components/microcomponents/ProvozovnaSelect.vue';
import SDA from '../../components/microcomponents/SDA.vue';
import MicroLakDruhSelect from '../../components/microcomponents/LakDruhSelect.vue';
import SlevaInputNumber from '../../components/microcomponents/SlevaInputNumer.vue';
import { EditMixin } from '../../mixins/editMixin';

export default mixins(PageModeMixin, EditMixin).extend({
	name: 'HlavniKarta',
	components: {
		MicroLakDruhSelect,
		ProvozovnaSelect,
		SlevaInputNumber,
		sda: SDA,
	},
	computed: {
		prevodMaxSuffix() {
			return ` (${this.PrevodMaxLimit ? this.PrevodMaxLimit : 0})`;
		},
		ddCustomerRevisitPrp() : boolean | null {
			return this.dmsSys.CustomerRevisitPrp && this.IsCustRevisit;
		},
	},
	methods: {},
});
